export default function() {
	return {
		scrolled: false,
		init() {
			this.checkScroll();
			window.addEventListener('scroll', () => this.checkScroll());

			this.$cleanup = () => {
				window.removeEventListener('scroll', () => this.checkScroll());
			};
		},
		checkScroll() {
			this.scrolled = window.scrollY > 70;
		}
	};
}
